export var generalColors={"--GW-BACKGROUND-COLOR-BODY":"#f0f1f5"};